import { State } from "./state.model"

export class City {
    ID?: number
    STATES_ID?: number
    CITY_NAME?: string
    CREATED_BY?: string
    CREATED_DATE?: Date
    MODIFIED_BY?: string
    MODIFIED_DATE?: Date

    STATE?: State
}
